import DefaultMapper, { toPagingAndSorting, addCustomMethods } from 'cw-core-admin-ui/src/dataProvider/DefaultMapper';
import { stringify } from 'query-string';
import { API_BASE_PATH_DEMOWALLET_ADMIN } from '../../../constants';

class MarketplaceSellerMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'marketplaces/sellers';
	}

	prepareCreate({ type, resource, params, options, mappedResource }) {
		switch (params.method) {
			case 'activate':
			case 'lock':
				options.method = 'POST';
				options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}/${params.id}${addCustomMethods(params)}`;
				options.body = JSON.stringify(params.data);
				break;
			default:
				options.method = 'POST';
				options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}`;
				options.body = JSON.stringify(params.data);
				break;
		}
	}

	prepareDeleteOne({ type, resource, params, options, mappedResource }) {
		options.method = 'DELETE';
		options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}/${params.id}`;
		options.body = JSON.stringify(params.data);
	}

	prepareGetList({ type, resource, params, options, mappedResource }) {
		const query = {
			...params.filter,
			...toPagingAndSorting(params),
		};
		options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}?${stringify(query)}`;
	}

	prepareGetOne({ type, resource, params, options, mappedResource }) {
		options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}/${params.id}`;
	}

	/**
	 * If the API doesn't return anything, it's the dataProvider's job to return the input data.
	 * Since we land here in case of a 2XX - we can simply override the empty response.
	 */
	finishDeleteOne({ type, resource, params, options, mappedResource, result }) {
		return { data: { id: params.id } };
	}
}

export default MarketplaceSellerMapper;
